import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootStore';

const useOrganizationGroups = () => {
  const groups = useSelector((state: RootState) => state.organization.groups.data);

  return { groups: (groups || []).filter((gr) => !gr.archived) };
};

export default useOrganizationGroups;
